export const UPDATE_CONSENTS = "UPDATE_CONSENTS";

export default {
    UPDATE_CONSENTS
};
